/* @flow */
import PropTypes from "prop-types";

import * as React from "react";

import { ArticleCardError } from "../article-badges/bundles/articlecard/ArticleCardError";
import { trackUiErrorSd } from "shared/src/utils/TrackingUtil";

type ArticleCardErrorBoundaryProps = {
    children?: React.ReactNode;
};

type ErrorBoundaryState = {
    errorOccurred: boolean;
};

class SearchResultArticleErrorBoundary extends React.Component<ArticleCardErrorBoundaryProps, ErrorBoundaryState> {
    static contextTypes = {
        intl: PropTypes.object.isRequired
    };

    constructor(props: ArticleCardErrorBoundaryProps) {
        super(props);
        this.state = { errorOccurred: false };
    }
    componentDidCatch(
        error: Error,
        errorInfo: {
            componentStack: string;
        }
    ) {
        trackUiErrorSd(errorInfo.componentStack, error.message, error);
        this.setState({ errorOccurred: true });
    }

    render() {
        if (this.state.errorOccurred) {
            const errorMessage = this.context?.intl?.formatMessage({ id: "EX_ARTICLE_BADGE_LOADING_ERROR" });
            return <ArticleCardError errorMessage={errorMessage} />;
        }
        return <React.Fragment>{this.props.children}</React.Fragment>;
    }
}

export default SearchResultArticleErrorBoundary;
